import { call, put, takeLatest } from "redux-saga/effects";
import { ACTIONS } from "./type";
import { IAction } from "../../modals/application";
import { getSettingsSuccess } from "./action";
import { getSettingsApi } from "../../services/application";

function* getSettings(action: IAction) {
    let { payload } = action;
    const { status, data } = yield call(getSettingsApi, payload);
    if (status) {
      yield put(getSettingsSuccess(data?.data));
    } 
}

export function* applicationWatcher() {
    yield takeLatest(ACTIONS.GET_SETTINGS_WATCHER, getSettings)
}